if (typeof CopsSlider !== 'function') {
  class CopsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = this.querySelector('.swiper');

      this.swipper;
      this.settings = {
        breakpoints: {
          0: {
            slidesPerView: 1,
            direction: "horizontal",
          },
          768: {
            slidesPerView: parseInt(this.dataset.slides),
            direction: "horizontal",
          },
        },
        loop: true,
        navigation: {
          nextEl: '.sliderControlNext',
          prevEl: '.sliderControlPrev',
        },
        spaceBetween: 0,
      };

      this.init();
      document.addEventListener('shopify:section:load', (event) => {
        if (typeof Swiper !== 'function') {
          this.appendAssets();
        }
        this.init();
      });
      window.addEventListener('resize', (event) => {
        this.init();
      });
    }
    appendAssets() {
      const link = document.createElement('link');
      const script = document.createElement('script');

      link.rel = 'stylesheet';
      link.id = 'swiper11Style';
      link.href = 'https://unpkg.com/swiper@11/swiper-bundle.min.css';
      script.id = 'swiper11Script';
      script.src = 'https://unpkg.com/swiper@11/swiper-bundle.min.js';

      document.head.appendChild(link);
      document.head.appendChild(script);
    }
    init() {
      if (typeof Swiper !== 'function') {
        this.appendAssets();

        document.addEventListener('readystatechange', () => {
          if (document.readyState == 'interactive') {
            this.initSlider();
          }
        });
      } else {
        this.initSlider();
      }
    }
    initSlider() {
      if (this.swipper && this.swipper.destroy) {
        this.swipper.destroy();
        this.swipper = null;

        this.swipper = new Swiper(this.swiper, this.settings);
      } else {
        this.swipper = new Swiper(this.swiper, this.settings);
      }
    }
  }

  customElements.define('cops-slider', CopsSlider);
}